<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：会员卡-会员卡列表
      -->
  <div class="user">

    <!--添加会员卡-->
    <div class="common-level-rail" style="float: right;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/plus/gradecard/add'">添加会员卡</el-button>
    </div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="会员等级" prop="card_num">
          <el-select v-model="formInline.grade_id" placeholder="请选择会员等级">
            <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批次：" prop="batch">
          <el-input v-model="formInline.batch"  placeholder="请输入批次"></el-input>
        </el-form-item>
        </el-form-item>
        <el-form-item label="是否导出">
          <el-select v-model="formInline.is_export" placeholder="是否导出">
          <el-option label="请选择" value=""></el-option>
            <el-option label="未导出" value="0"></el-option>
            <el-option label="已导出" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="batch" label="批次"></el-table-column>
          <el-table-column prop="grade_id" label="会员等级id"></el-table-column>
          <el-table-column prop="grade.name" label="会员等级名称"></el-table-column>
          <el-table-column prop="card_num" label="会员卡数量"></el-table-column>
          <el-table-column prop="use_num" label="已使用会员卡数量"></el-table-column>
          <el-table-column prop="expiry_date" label="会员有效期(天)"></el-table-column>
          <el-table-column prop="is_export" label="是否导出" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_export == 0" class="green">未导出</span>
              <span v-if="scope.row.is_export == 1" class="green">已导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_time" label="导出时间" width="140">

          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/plus/gradecard/detail'">详情</el-button>
              <el-button  type="text" size="small" @click="onExport(scope.row)" v-auth="'/plus/gradecard/export'">导出</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import GradeCardApi from '@/api/gradecard.js';
export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      gradeList: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        product_name: '',
        batch: '',
        is_export:'',
      },
      /*是否打开添加弹窗*/
      open_add: false,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      GradeCardApi.GradeCardlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.gradeList = data.data.gradeList;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*导出数据*/
    onExport(row) {


      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.gradecard.GradeCard/export?batch='+row.batch;

    },


    /*打开添加*/
    addClick() {
      this.$router.push('/plus/GradeCard/add');
    },


    /*打开详情*/
    detailClick(row) {
      this.$router.push({
        path: '/plus/GradeCard/detail',
        query: {
          batch: row.batch,

        }
      });
    },

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/gradecard/index.vue